import { createAsyncThunk } from "@reduxjs/toolkit";
import magnifiAPI from "services/api/magnifi";

export const getIngestionData = createAsyncThunk("ingestion/getIngestionData", async (payload) => {
  try {
    const response = await magnifiAPI.getIngestionData(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const changeIngestionStatus = createAsyncThunk(
  "ingestion/changeIngestionStatus",
  async ({ payload, entityId }) => {
    try {
      const response = await magnifiAPI.changeIngestionStatus({ payload, entityId });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
